import Swiper, { Lazy, Navigation, Thumbs, Grid } from "swiper";
import TomSelect from "tom-select";
import ContactForm from "../modules/contact-form";
import ProductCalculator from "../modules/product-calculator";

const SingleProduct = {
  init() {
    ContactForm.init();
    ProductCalculator.init();

    SingleProduct.events();
    SingleProduct.related();
    SingleProduct.attributes();
    SingleProduct.productGallery();
    SingleProduct.relatedProductsSlider();
    SingleProduct.tooltipMobile();
  },

  events() {
    $(".single_add_to_cart_button:not(button)").on("click", function (e) {
      if (e.currentTarget.classList.contains("wc-variation-is-unavailable")) {
        e.stopPropagation();

        $("html, body").animate(
          {
            scrollTop: $("#contact").offset().top - 200,
          },
          500
        );
      }
    });

    SingleProduct.variationForm();
    $(".variations_form select").on("change", () => {
      SingleProduct.variationForm();
    });

    // Add TomSelect to attribute selects
    $(".variations_form select").each(function () {
      const selectEl = $(this);

      new TomSelect(selectEl[0], {
        controlInput: null,
        render: {
          option: function (data, escape) {
            // Check if data has inactive key
            if ("inactive" in data) {
              return "<div data-inactive>" + escape(data.text) + "</div>";
            }

            return "<div>" + escape(data.text) + "</div>";
          },
        },
      });
    });

    // Scroll to contact form
    $("body").on("click", ".js-prod-request", function (e) {
      e.preventDefault();

      $("html, body").animate(
        {
          scrollTop: $("#contact").offset().top - 200,
        },
        500
      );
    });
  },

  variationForm() {
    const variationFormEl = $(".variations_form");
    if (!variationFormEl.length) {
      return;
    }

    let selectedVariations = {};
    variationFormEl.find("select").each(function () {
      const select = $(this);

      selectedVariations[select.attr("name")] = select.val();
    });

    const variations = variationFormEl.data("product_variations");

    const selectedVariation = variations.find((variation) => {
      return Object.keys(selectedVariations).every((key) => {
        return selectedVariations[key] == variation.attributes[key];
      });
    });

    if (!selectedVariation) {
      return;
    }

    const prodReqSkuEl = $('input[name="product_sku"]');
    if (prodReqSkuEl.length && selectedVariation.sku) {
      prodReqSkuEl.val(selectedVariation.sku);
    }

    // Handle add to cart button
    if (parseInt(selectedVariation.max_qty) > 0) {
      $(".js-prod-add").removeClass("hidden");
      $(".js-prod-request").addClass("hidden");
    } else {
      $(".js-prod-add").addClass("hidden");
      $(".js-prod-request").removeClass("hidden");
    }

    if (
      Number(selectedVariation.display_regular_price) > Number(selectedVariation.display_price)
    ) {
      $(".sale-badge").removeClass("hidden");
      $(".variable-product-price-regular").text(
        selectedVariation.display_regular_price
      );

      if (selectedVariation.meter_price_regular) {
        $(".sale-badge__meter-price").removeClass("hidden");
        $(".variable-product-meter-regular").text(
          selectedVariation.meter_price_regular
        );
      } else {
        $(".sale-badge__meter-price").addClass("hidden");
      }
    } else {
      $(".sale-badge").addClass("hidden");
      $(".sale-badge__meter-price").addClass("hidden");
    }

    if (selectedVariation.boards_in_pack) {
      $(".var-bip").val(selectedVariation.boards_in_pack);
      $(`[name="boards-in-pack"]`).val(selectedVariation.boards_in_pack);
    }

    if (selectedVariation.board_gap) {
      $(".var-gap").val(selectedVariation.board_gap);
    }

    if (selectedVariation.display_price) {
      $(".var-price").val(selectedVariation.display_price);
    }

    if (selectedVariation.elegible_parcel_shipping) {
      $(".variable-product__parcel").removeClass("hidden");
    } else {
      $(".variable-product__parcel").addClass("hidden");
    }
    $(".variable-product-price").html(selectedVariation.display_price);
    $(".variable-product-meter").html(selectedVariation.meter_price);
  },

  related() {
    const relatedEl = $(".related-products");
    if (!relatedEl.length) {
      return;
    }

    const sliderEl = relatedEl.find(".related-products-slider");

    new Swiper(sliderEl[0], {
      modules: [Lazy, Navigation],
      slidesPerView: 1,
      spaceBetween: 30,
      loop: false,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
      },
      navigation: {
        prevEl: relatedEl.find(".swiper-prev"),
        nextEl: relatedEl.find(".swiper-next"),
      },
      breakpoints: {
        480: {
          slidesPerView: 2,
        },
        900: {
          slidesPerView: 3,
        },
        1200: {
          slidesPerView: 4,
        },
      },
    });
  },

  attributes() {
    const attrEl = $(".attributes");
    if (!attrEl.length) {
      return;
    }

    $(".attributes__more-btn").on("click", function (e) {
      e.preventDefault();
      const btn = $(this);
      const expandEl = btn.siblings(".attributes__expand");

      if (attrEl.hasClass("open")) {
        attrEl.removeClass("open");
        expandEl.slideToggle();
        btn.find("span").text("Vairāk");
      } else {
        attrEl.addClass("open");
        expandEl.slideToggle();
        btn.find("span").text("Mazāk");
      }
    });
  },

  productGallery() {
    const wrapEl = $(".product__gallery");
    if (!wrapEl.length) {
      return;
    }

    const thumbsSliderEl = wrapEl.find(".gallery-thumbs");
    const gallerySliderEl = wrapEl.find(".gallery-slider");

    var thumbsSwiper = new Swiper(thumbsSliderEl[0], {
      modules: [Grid, Thumbs],
      spaceBetween: 8,
      slidesPerView: "auto",

      freeMode: true,
      watchSlidesProgress: true,
    });

    var largeSwiper = new Swiper(gallerySliderEl[0], {
      modules: [Lazy, Navigation, Thumbs],
      slidesPerView: 1,
      spaceBetween: 16,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
      },
      thumbs: {
        swiper: thumbsSwiper,
      },
    });
  },

  relatedProductsSlider() {
    const wrapEl = $(".related");
    if (wrapEl.length) {
      let swiperInstance;

      function initializeSwiper() {
        let navEl = ".slider-nav";
        if (window.innerWidth < 900) {
          navEl = ".slider-nav--mobile";
        }

        swiperInstance = new Swiper(wrapEl.find(".related__slider")[0], {
          modules: [Lazy, Navigation],
          lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: 1,
          },
          navigation: {
            prevEl: wrapEl.find(`${navEl} .slider-nav__btn-prev`)[0],
            nextEl: wrapEl.find(`${navEl} .slider-nav__btn-next`)[0],
          },
          slidesPerView: "auto",
          spaceBetween: 16,
          loop: false,
        });
      }

      initializeSwiper(); // Initialize Swiper initially

      // Update Swiper on window resize
      $(window).on("resize", function () {
        // Destroy previous instance if it exists
        if (swiperInstance) {
          swiperInstance.destroy();
        }
        // Reinitialize Swiper with updated options
        initializeSwiper();
      });
    }
  },

  tooltipMobile() {
    const calcEl = $(".calc");
    if (!calcEl.length) {
      return;
    }

    const tooltipEl = $(".calc__tooltip");
    const bubble = $(".tooltip-mobile");
    const closeBtn = $(".tooltip-mobile__close");

    if (window.innerWidth < 900) {
      tooltipEl.on("click", function () {
        bubble.toggleClass("hidden");
      });

      closeBtn.on("click", function (e) {
        e.preventDefault();
        bubble.addClass("hidden");
      });
    }
  },
};

export default SingleProduct;
